import styled, { css } from 'styled-components';

export const StyledDemoContainer = styled.div(({ theme }) => {
  const {
    base: {
      'content-width': { md }
    }
  } = theme;

  return css`
    max-width: ${md};
  `;
});
